import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'state/store'
import { interactionModelOperations } from '../redux'
import { InteractionModel } from 'types/shared'
import useInteraction from './useInteraction'
import useBaseInteractionUuid from './useBaseInteractionUuid'

type UseBaseInteractionParams = {
  enabled?: boolean
}

const useBaseInteraction = ({ enabled = true }: UseBaseInteractionParams) => {
  const { flatData, isBaseInteractionApplied } = useAppSelector(
    (state) => state.interactionModel
  )

  const baseInteractionUuid = useBaseInteractionUuid(flatData?.base_interaction)

  const dispatch = useAppDispatch()
  const { yesObject: baseInteraction, isFetched } = useInteraction({
    interactionUuid: baseInteractionUuid
  })

  useEffect(() => {
    if (baseInteraction && enabled && !isBaseInteractionApplied) {
      try {
        const parsedState = JSON.parse(
          baseInteraction.state || 'null'
        ) as InteractionModel | null

        if (!parsedState) return

        dispatch(
          interactionModelOperations.setValuesFromBaseInteraction(
            parsedState.flatData
          )
        )
      } catch (error) {
        console.error('Failed to parse base interaction state:', error)
      }
    }
  }, [baseInteraction, enabled, isBaseInteractionApplied, dispatch])

  return {
    baseInteraction,
    isFetched
  }
}

export default useBaseInteraction
